import React from 'react';

import './express_interest.scss'

import AsyncSelect from 'react-select/async';
import axios from 'axios';

let selectBorderColor = '#CED4DA'
const selectStyle = {
  control: (base, state) => ({
    ...base,
    border: `1px solid ${selectBorderColor}`,
    boxShadow: 'none',
    '&:hover': {
      border: `1px solid ${selectBorderColor}`,
    },
    fontFamily: "Montserrat",
    fontWeight: 400,
    height: 55,
    borderRadius: 0,
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#7D0052' : 'inherit',
    '&:hover': {backgroundColor: state.isSelected ? '#7D0052' : '#ECECEC'},
  })
}

class ExpressInterestForm extends React.Component {
  state = {
    content: [],
    setValue: '',
    selectedValue: null,
  };

  componentWillMount() {
    axios.get('/' + this.props.locale +'/sign_up_content').then((res) => { this.setState({ content: res.data.data.data }); });
  }

  handleChange = (e) => {
    const alreadyExistsMessage = document.getElementById('alreadyExistsMessage');
    alreadyExistsMessage.innerHTML = ''

    const target = e.currentTarget;
    target.required = true
    this.form.validateFields(target);
  }

  handleInputChange = value => {
    this.setState({ setValue: value });
  };

  handleSelectChange = value => {
    this.setState({ selectedValue: value });
    selectBorderColor = '#CED4DA'
    document.getElementById('institution-validation').hidden = true
  }

  handleNoOptionsMessage = inputValue => {
    const { content } = this.state;
    if (inputValue.length == 0) {
      return content.startTypingMessage
    }
    else {
      return content.noOptionsMessage
    }
  }

  loadOptions = (inputValue) => {
    return axios.get('/institutions/for_select?institution=' + inputValue).then((res) => res.data.data );
  };

  render() {
    const { selectedValue, content } = this.state;
    return (
              <div id='lop'>
                <AsyncSelect
                    value={selectedValue}
                    loadOptions={this.loadOptions}
                    onInputChange={this.handleInputChange}
                    onChange={this.handleSelectChange}
                    styles={selectStyle}
                    placeholder={content.institutionPlaceholder}
                    name={'user_lead[institution_id]'}
                    noOptionsMessage={({inputValue}) => this.handleNoOptionsMessage(inputValue)}
                />
              </div>
    );
  }
}


export default ExpressInterestForm;
